import React, { useEffect } from "react";
import { useSnackBar } from "~/components/snackbar";
import { subscribeToUncaughtErrors } from "./globalErrorListener";

const genericMessage = "Whoops! Something went wrong; please try again.";
const networkMessage =
  "Can't reach the server - please check your internet connection";

/**
 * Tells the user when something has gone wrong. Capture and reporting happen in
 * the global error listener, which errorReporting.tsx installs at startup; this
 * only chooses the notification.
 */
export const GlobalErrorHandler: React.FC = () => {
  const addAlert = useSnackBar();

  useEffect(
    () =>
      subscribeToUncaughtErrors((_error, classification) => {
        addAlert({
          key: "global-error-handler",
          message:
            classification.kind === "network" ? networkMessage : genericMessage,
          isSuccess: false,
        });
      }),
    []
  );

  return null;
};
